/* eslint-disable max-len */

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  yesterday: 'yesterday',
  today: 'today',
  empty: {
    messages: 'No messages found',
    'key-events': 'No key events found.',
    'referenced-people': 'No referenced people found.',
    topics: 'No topics found.'
  },

  DisplayTitleFilterComponent: {
    headline: 'Filter',
    note: 'The filter status box shows the current filtering of the selected search input. Individual filters can also be removed. Searchable entities can be opened in a new view by clicking on them. Each additional filter displays a subset of assets of the original selection.'
  },

  LatestEventsComponent: {
    headline: 'Latest Events',
    note: 'These signals are based on general rules based on short term buzz and sentiment changes. For example if an asset crosses a certain buzz level or if it shows significant sentiment changes.',
    'no-signals-found': 'No Signals found',
    cta: 'No new events | Show new event | Show {count} new events'
  },
  LoadDataWithSelectedPeriod: 'Load data with selected period',
  SearchPage: {
    period: {
      last_week: 'Last week',
      last_month: 'Last month',
      last_year: 'Last year',
      any_time: 'Any time'
    },
    moreDataButton: {
      label: 'Want more history or real-time data?'
    },
    disclaimer: {
      title: 'Disclaimer',
      priceIndicationInfo: 'All stock prices shown on this page are based on Stockpulse price indications.',
      text: 'Stock exchange transactions, particularly forward, future, and options trading imply risks which can lead to a total loss of\n' +
        'your entire capital employed and other losses. Get professional and detailed advice from your bank about relevant loss risks\n' +
        'before making your investment decisions.\n' +
        'The information and data available on this page are only for information purposes. Stockpulse does\n' +
        'neither provide investment consulting or investment brokerage nor the call of buying or selling stocks, forwards, futures, or\n' +
        'options. Despite extraordinary diligence Stockpulse cannot take responsibility for the\n' +
        'correctness, accurateness, or completeness of the information presented here. Each stock\n' +
        'volatility prediction as well as all given trading signals represent the exclusive opinion of Stockpulse, do not contain any\n' +
        'responsibility, do not represent any promises on future earnings, and are no call for imitation not even by implication.\n' +
        'Earnings realized in the past do not guarantee future earnings. This especially applies for trading signals. We explicitly point\n' +
        'out that it is possible that the suggestions generated by Stockpulse are not necessarily happening in real stock exchange\n' +
        'trading. We exclude liability for financial losses.\n' +
        'Stockpulse is not responsible for any loss arising from any investment based on a perceived recommendation.\n' +
        'Everybody who is using and registering for Stockpulse accepts the terms and conditions of the Stockpulse GmbH. Visiting\n' +
        'the Stockpulse Websites does not automatically imply a customer relationship.\n' +
        'There are no responsibilities, commitment, or liability with respect to persons or organizations.\n' +
        'The statements on this page shall not be considered as an objective or independent explanation of the matters. Please\n' +
        'note that this page (a) has not been prepared in accordance with legal requirements designed to promote the\n' +
        'independence of investment research, and (b) is not subject to any prohibition on dealing ahead of the dissemination or\n' +
        'publication of investment research.'
    }
  },
  ContactSalesDialogComponent: {
    title: 'Are you interested?',
    email: {
      label: 'Email',
      placeholder: 'Your email',
      validation: {
        error: 'Please enter a valid email address'
      }
    },
    firstname: {
      label: 'Firstname',
      placeholder: 'Your firstname'
    },
    lastname: {
      label: 'Lastname',
      placeholder: 'Your lastname'
    },
    message: {
      label: 'Message',
      placeholder: 'Your message'
    },
    submit: {
      error: 'Error submitting form'
    }
  },
  SearchComponent: {
    SearchQuery: {
      placeholder: 'Search any financial topic…'
    },
    Submit: {
      label: 'Search'
    }
  },
  TrendingTitlesComponent: {
    headline: {
      topSelection: 'Trending Assets',
      indexes: 'Trending Indexes'
    }
  },
  TrendingKeyEvents: {
    headline: 'Trending Key Events'
  },
  TimeRangeSelectionService: {
    confirm: {
      text: 'Please note: Loading the data for this period may take some time, possibly a few minutes.',
      continueButton: 'Continue',
      additionalInfo: 'The search result will contain no messages. | The search result will contain approx. 1 message. | The search result will contain approx. {messageCount} messages.'
    }
  },
  AuthorView: {
    headline: {
      impactScore: 'Impact Score',
      messages: 'Messages',
      botScore: 'Bot Likeliness Score',
      authorHistoryChartComponent: 'Previous Message Distribution',
      authorMessageStatistics: 'Message Statistics',
      sameAuthorNameOtherSources: 'Same Author Name in other sources',
      titlesMentioned: 'Previous Mentioned Assets',
      assetDistribution: 'Mentioned Assets'
    },
    note: {
      impactScore: 'The Impact Score of an author or user can range from 0 to 5. 0 means the author was classified as bot and will be on a blacklist. A score of 5 means that these authors are most credible. All authors with a score of 5 are manually curated. There is an automatic ranking of scores between 1 and 4. This depends on the source, because there are different data points for every source. E.g. for X/Twitter we know the number of followers, following, the creation date of the account and the number of tweets. Based on these metrics it is possible to calculate a score which will then be represented in the Impact Score.',
      authorMessageStatistics: 'The message statistics for a single author show how active the author was recently and in the past. The number of messages per time interval provide an impression of the activity of the author.',
      titlesMentioned: 'The assets mentioned box show about which assets the author mostly discusses, also over time.'
    }
  },
  AssetSnapshot: {
    headline: {
      hottestTopics: 'Hottest Topics about',
      spreadsheet: 'Spreadsheet'
    },
    note: {
      hottestTopics: 'These are topics that are extracted with our own AI and LLM from latest news articles. By changing the time period on the right upper side of the screen will also lead to the processing of different news that match to the set time period. Therefore the selection of topics can vary based on the selected time period.',
      'author-analytics': 'The bar chart shows the relative distribution of the authors to our author categories.',
      spreadsheet: 'The spreadsheet widget provides the option to download historical buzz and sentiment data for three time slot: minutes, hours, and daily.'
    }
  },
  TitleMasterDataComponent: {
    headline: 'Fundamentals',
    note: 'This shows some important base data for the entity.'
  },
  BuzzSentimentTreeMap: {
    headline: 'Buzz Sentiment Map',
    note: 'The Buzz Sentiment Map shows an aggregated overview for a list of stocks, e.g. an index or a country/region. The size of the rectangle indicates the level of buzz (the larger the higher the buzz) and the color indicates the sentiment (green means rather positive mood and red means rather negative mood).'
  },
  AssetSentimentTreeMap: {
    headline: 'Buzz Sentiment Map',
    note: 'The Asset Sentiment Map shows an aggregated overview for mentioned assets. The size of the rectangle indicates the number of messages and the color indicates the sentiment (green means rather positive mood and red means rather negative mood).'
  },
  KeyEventsTreeMap: {
    headline: 'Key Event Map Top 10',
    note: 'The Key Event Map shows an aggregated overview for a list of stocks, e.g. an index or a country/region. The size of the rectangle indicates the number of messages with the given key event and the color indicates the sentiment (green means rather positive mood and red means rather negative mood).'
  },
  TitleTechnicalDataComponent: {
    headline: 'Technical Data',
    note: 'This shows some important technical numbers.'
  },
  LastSignificantPriceChangesComponent: {
    headline: 'Last Significant Price Changes',
    note: 'This widget displays the highest price changes in the stock price of the selected entity.'
  },
  ShortSalesComponent: {
    headline: 'Short info',
    note: 'This displays the current short sale data for the entity.'
  },
  ShortSalesUsComponent: {
    headline: 'Short info US',
    note: 'This displays the current short sale data for the entity.'
  },
  BuzzSentimentChartComponent: {
    headline: 'Chart',
    note: 'The chart displays the buzz and sentiment values over time. The initial time period of the chart depends on the general time period for the selected entity. The time can be changed to different periods with a separate setting. This allows to zoom out and see larger time periods in order to see a bigger picture of the development of buzz and sentiment over time. The time slider at the bottom of the chart allows to narrow the time frame to a specified time.'
  },
  WatchlistComponent: {
    headline: 'Trending in my watchlist',
    note: 'The widget shows the currently most discussed stocks and views from your own watchlist.'
  },
  VisitedPagesHistoryComponent: {
    headline: 'My page history',
    note: 'This box lists all previous searches of the current session.'
  },
  PreIPOCompaniesComponent: {
    headline: 'Pre IPO companies',
    note: 'This box shows upcoming IPOs and the current buzz level of IPO companies.'
  },
  AssetsComponent: {
    headline: 'Top Related Assets',
    note: 'The Top Related Assets widget shows those assets that are currently mostly related to the selected search query. These assets are mostly mentioned with the selected search query in the communication or the news. This also depends on the selected time period on the upper right side of the screen.'
  },
  TitleDescriptionComponent: {
    headline: 'Description',
    note: 'Basic description of the selected asset.'
  },
  MessageStatistics: {
    title: '{query}: Results',
    headline: {
      authors: 'Authors',
      buzz: 'Buzz',
      'most-mentioned-key-events': 'Key Events',
      'key-events': 'Key Events',
      languages: 'Languages',
      messages: 'Messages',
      messagesList: 'Messages',
      'referenced-people': 'Referenced People',
      sentiment: 'Sentiment',
      sources: 'Sources',
      types: 'Types',
      'top-authors': 'Top Authors',
      titles: 'Top Related Assets',
      topics: 'Topics',
      'author-analytics': 'Author Analytics'
    },
    note: {
      to: 'to',
      messages: 'Number of analyzed messages in the selected time range. Additionally, the chart displays the number of messages where the search term was found in over time (refers to our Buzz indicator). It shows the development over the selected time period.',
      messagesList: 'The widget shows all messages for the selected time period. More messages are loaded by scrolling in the messages widget. If a certain time period is of interest, the time period can be adjusted and messages for this time period will be loaded accordingly.',
      authors: 'The number represents the different authors/users who posted the messages in the selected time period.',
      sources: 'The number represents the different sources of the messages in the selected time period. Generally, we cover thousands of different sources in real time. These include traditional media/news and social media. Usually, a few large social media sources contribute most messages.',
      buzz: 'Buzz is a measure of the strength of the communication about a stock. The value is always based on the average\ncommunication about the respective stock. Average is 100%. Additionally the chart shows the buzz of the last 30 days.\n',
      sentiment: 'The sentiment represents the meaning/tonality of the content of the messages. The value/bar chart that is displayed aggregates the sentiment of the individual messages over the selected time period. In addition, the chart shows sentiment over time. It shows the development over the selected time period. In general, sentiment is based on Natural Language Processing (NLP).',
      'source-distribution': 'The pie chart shows the distribution of messages for the sources with the most news and social media posts found for the selected entity.',
      'type-distribution': 'The bar chart shows the different message types for the selected entity. The numbers represent the number of messages posted in each category. It distinguishes between these main types: tweets, comments (e.g. from sites like X, Reddit, Discord or Telegram), forum posts (from classic message boards), news (traditional news), adhoc (company announcements), and other filing categories.',
      'author-distribution': 'The bar chart shows the top authors/users with the most posts for the selected entity. The numbers represent the number of messages posted by the author in the selected time period.',
      'language-distribution': 'The bar chart shows the most frequently detected languages in the found messages. The numbers represent the number of messages in the respective language in the selected time period.',
      'key-events': 'The box shows the most frequently mentioned key events/topics (in the selected time period) detected in the related messages. The numbers in the blue bubbles represent the number of occurrences of the specified key event term in the messages.',
      'most-mentioned-key-events': 'This widget displays the most mentioned key events or topics for the asset and the specified time period. The selection of topics depends on the time period. It is possible to see the development of most mentioned topics over time which provide a very good overview of the main focus of communication about this entity.',
      'referenced-people': 'The box shows the most mentioned people/person names detected in the related messages. The numbers represent the number of occurrences of the specified people/persons in the messages.',
      'title-distribution': 'This box shows a financial instrument and the corresponding price development of the last 30 days that is closely related to the search term. For general search terms (e.g. not a specific stock or crypto currency), the most frequently mentioned financial instrument is displayed. The number of mentions are extracted from all sources Stockpulse monitors. The displayed share price is the last close price. The change value refers to the change of the last close and the close of the trading day before the last close.',
      topics: 'These topics were generated by Stockpulse\' AI. The topics are derived from recent news articles related to the search query.',
      'author-analytics': 'The bar chart shows the relative distribution of the authors to our author categories.',
      positiveMessages: 'Amount of positive Messages',
      negativeMessages: 'Amount of negative Messages'
    },
    empty: {
      messages: 'No messages found',
      'key-events': 'No key events found.',
      'referenced-people': 'No referenced people found.',
      topics: 'No topics found.'
    },
    others: 'others',
    type: {
      account: 'Account',
      adhoc: 'Adhoc',
      adv_fin_report: 'Advanced Financial Report',
      analyst: 'Analyst',
      annual_meeting: 'Annual Meeting',
      blog: 'Blog',
      buzz: 'Buzz',
      cap_mkt_info: 'Capital Market Information',
      comments: 'Comments',
      dir_dealings: 'Director Dealings',
      filings: 'Filings',
      forum_posts: 'Forum Posts',
      images: 'Images',
      nav: 'Net Asset Value Report',
      news: 'News',
      regulatory: 'Regulatory',
      short_interest: 'Short Interest',
      takeover_offer: 'Takeover Offer',
      tweets: 'Tweets',
      videos: 'Videos',
      voting_rights: 'Voting Rights',
      others: 'others'
    },
    language: {
      ab: 'Abkhazian',
      aa: 'Afar',
      af: 'Afrikaans',
      ak: 'Akan',
      sq: 'Albanian',
      am: 'Amharic',
      ar: 'Arabic',
      an: 'Aragonese',
      hy: 'Armenian',
      as: 'Assamese',
      av: 'Avaric',
      ae: 'Avestan',
      ay: 'Aymara',
      az: 'Azerbaijani',
      bm: 'Bambara',
      ba: 'Bashkir',
      eu: 'Basque',
      be: 'Belarusian',
      bn: 'Bengali',
      bi: 'Bislama',
      bs: 'Bosnian',
      br: 'Breton',
      bg: 'Bulgarian',
      my: 'Burmese',
      ca: 'Catalan, Valencian',
      ch: 'Chamorro',
      ce: 'Chechen',
      ny: 'Chichewa, Chewa, Nyanja',
      zh: 'Chinese (zh)',
      cn: 'Chinese (cn)',
      cu: 'Church Slavonic, Old Slavonic, Old Church Slavonic',
      cv: 'Chuvash',
      kw: 'Cornish',
      co: 'Corsican',
      cr: 'Cree',
      hr: 'Croatian',
      cs: 'Czech',
      da: 'Danish',
      dv: 'Divehi, Dhivehi, Maldivian',
      nl: 'Dutch, Flemish',
      dz: 'Dzongkha',
      en: 'English',
      eo: 'Esperanto',
      et: 'Estonian',
      ee: 'Ewe',
      fo: 'Faroese',
      fj: 'Fijian',
      fi: 'Finnish',
      fr: 'French',
      fy: 'Western Frisian',
      ff: 'Fulah',
      gd: 'Gaelic, Scottish Gaelic',
      gl: 'Galician',
      lg: 'Ganda',
      ka: 'Georgian',
      de: 'German',
      el: 'Greek: Modern',
      kl: 'Kalaallisut, Greenlandic',
      gn: 'Guarani',
      gu: 'Gujarati',
      ht: 'Haitian, Haitian Creole',
      ha: 'Hausa',
      he: 'Hebrew',
      hz: 'Herero',
      hi: 'Hindi',
      ho: 'Hiri Motu',
      hu: 'Hungarian',
      is: 'Icelandic',
      io: 'Ido',
      ig: 'Igbo',
      id: 'Indonesian',
      ia: 'Interlingua',
      ie: 'Interlingue, Occidental',
      iu: 'Inuktitut',
      ik: 'Inupiaq',
      ga: 'Irish',
      it: 'Italian',
      ja: 'Japanese',
      jv: 'Javanese',
      kn: 'Kannada',
      kr: 'Kanuri',
      ks: 'Kashmiri',
      kk: 'Kazakh',
      km: 'Central Khmer',
      ki: 'Kikuyu, Gikuyu',
      rw: 'Kinyarwanda',
      ky: 'Kirghiz, Kyrgyz',
      kv: 'Komi',
      kg: 'Kongo',
      ko: 'Korean',
      kj: 'Kuanyama, Kwanyama',
      ku: 'Kurdish',
      lo: 'Lao',
      la: 'Latin',
      lv: 'Latvian',
      li: 'Limburgan, Limburger, Limburgish',
      ln: 'Lingala',
      lt: 'Lithuanian',
      lu: 'Luba-Katanga',
      lb: 'Luxembourgish, Letzeburgesch',
      mk: 'Macedonian',
      mg: 'Malagasy',
      ms: 'Malay',
      ml: 'Malayalam',
      mt: 'Maltese',
      gv: 'Manx',
      mi: 'Maori',
      mr: 'Marathi',
      mh: 'Marshallese',
      mn: 'Mongolian',
      na: 'Nauru',
      nv: 'Navajo: Navaho',
      nd: 'North Ndebele',
      nr: 'South Ndebele',
      ng: 'Ndonga',
      ne: 'Nepali',
      no: 'Norwegian',
      nb: 'Norwegian Bokmål',
      nn: 'Norwegian Nynorsk',
      ii: 'Sichuan Yi, Nuosu',
      oc: 'Occitan',
      oj: 'Ojibwa',
      or: 'Oriya',
      om: 'Oromo',
      os: 'Ossetian, Ossetic',
      pi: 'Pali',
      ps: 'Pashto, Pushto',
      fa: 'Persian',
      pl: 'Polish',
      pt: 'Portuguese',
      pa: 'Punjabi, Panjabi',
      qu: 'Quechua',
      ro: 'Romanian, Moldavian, Moldovan',
      rm: 'Romansh',
      rn: 'Rundi',
      ru: 'Russian',
      se: 'Northern Sami',
      sm: 'Samoan',
      sg: 'Sango',
      sa: 'Sanskrit',
      sc: 'Sardinian',
      sr: 'Serbian',
      sn: 'Shona',
      sd: 'Sindhi',
      si: 'Sinhala, Sinhalese',
      sk: 'Slovak',
      sl: 'Slovenian',
      so: 'Somali',
      st: 'Southern Sotho',
      es: 'Spanish: Castilian',
      su: 'Sundanese',
      sw: 'Swahili',
      ss: 'Swati',
      sv: 'Swedish',
      tl: 'Tagalog',
      ty: 'Tahitian',
      tg: 'Tajik',
      ta: 'Tamil',
      tt: 'Tatar',
      te: 'Telugu',
      th: 'Thai',
      bo: 'Tibetan',
      ti: 'Tigrinya',
      to: 'Tonga (Tonga Islands)',
      ts: 'Tsonga',
      tn: 'Tswana',
      tr: 'Turkish',
      tk: 'Turkmen',
      tw: 'Twi',
      ug: 'Uighur, Uyghur',
      uk: 'Ukrainian',
      ur: 'Urdu',
      uz: 'Uzbek',
      ve: 'Venda',
      vi: 'Vietnamese',
      vo: 'Volapük',
      wa: 'Walloon',
      cy: 'Welsh',
      wo: 'Wolof',
      xh: 'Xhosa',
      yi: 'Yiddish',
      yo: 'Yoruba',
      za: 'Zhuang, Chuang',
      zu: 'Zulu',
      'n/a': 'n/a',
      others: 'others'
    },
    keyEvent: {
      Merger: 'Merger',
      Acquisition: 'Acquisition',
      'Joint Venture': 'Joint Venture',
      'Partnership Created': 'Partnership Created',
      'Partnership Terminated': 'Partnership Terminated',
      'Board Member Death': 'Board Member Death',
      'Board Member Firing': 'Board Member Firing',
      'Board Member Resignation': 'Board Member Resignation',
      'Executive Death': 'Executive Death',
      'Executive Firing': 'Executive Firing',
      'Executive Resignation': 'Executive Resignation',
      'Executive Retirement': 'Executive Retirement',
      'Drug Approval': 'Drug Approval',
      'Accelerated Drug Approval': 'Accelerated Drug Approval',
      'Breakthrough Therapy': 'Breakthrough Therapy',
      'Orphan Drug': 'Orphan Drug',
      'Clinical Trials': 'Clinical Trials',
      'Priority Review': 'Priority Review',
      'Patient Enrollment': 'Patient Enrollment',
      Bankruptcy: 'Bankruptcy',
      'Bankruptcy Exit': 'Bankruptcy Exit',
      'Bankruptcy Fears': 'Bankruptcy Fears',
      'Pay-per-Use': 'Pay-per-Use',
      'Earnings Guidance': 'Earnings Guidance',
      'Earnings Release': 'Earnings Release',
      'Earnings Down': 'Earnings Down',
      'Earnings Unchanged': 'Earnings Unchanged',
      'Earnings Up': 'Earnings Up',
      'Earnings Revision': 'Earnings Revision',
      'Earnings Misstatement': 'Earnings Misstatement',
      'Earnings Delayed': 'Earnings Delayed',
      EBIT: 'EBIT',
      EBITA: 'EBITA',
      EBITDA: 'EBITDA',
      'Interest Income': 'Interest Income',
      'Operating Earnings': 'Operating Earnings',
      'Pretax Earnings': 'Pretax Earnings',
      'Twitter IPO': 'Twitter IPO',
      'Analyst Downgrade': 'Analyst Downgrade',
      'Analyst Upgrade': 'Analyst Upgrade',
      'Analyst Ratings Unchanged': 'Analyst Ratings Unchanged',
      'Analyst Report': 'Analyst Report',
      'Insider Buy': 'Insider Buy',
      'Insider Gift': 'Insider Gift',
      'Insider Sell': 'Insider Sell',
      'Insider Trading Lawsuit': 'Insider Trading Lawsuit',
      'Insider Sell Registration': 'Insider Sell Registration',
      'Insider Surrender': 'Insider Surrender',
      Drilling: 'Drilling',
      'Resource Discovery': 'Resource Discovery',
      'Dividend Expectations': 'Dividend Expectations',
      'Dividend Down': 'Dividend Down',
      'Dividend Suspended': 'Dividend Suspended',
      'Dividend Unchanged': 'Dividend Unchanged',
      'Dividend Up': 'Dividend Up',
      'Automobile Accident': 'Automobile Accident',
      'Aircraft Accident': 'Aircraft Accident',
      'Dam Accident': 'Dam Accident',
      'Facility Accident': 'Facility Accident',
      'Factory Accident': 'Factory Accident',
      'Force Majeure': 'Force Majeure',
      'Freight Transport Accident': 'Freight Transport Accident',
      'Mine Accident': 'Mine Accident',
      'Pipeline Accident': 'Pipeline Accident',
      'Platform Accident': 'Platform Accident',
      'Power Outage': 'Power Outage',
      'Power Plant Accident': 'Power Plant Accident',
      'Public Transport Accident': 'Public Transport Accident',
      'Refinery Accident': 'Refinery Accident',
      Spill: 'Spill',
      'Tanker Accident': 'Tanker Accident',
      'Auditor Appointment': 'Auditor Appointment',
      'Auditor Resignation': 'Auditor Resignation',
      'Exchange Compliance': 'Exchange Compliance',
      'Exchange Noncompliance': 'Exchange Noncompliance',
      'Regulatory Investigation': 'Regulatory Investigation',
      'Short Selling Ban': 'Short Selling Ban',
      'Credit Rating Affirmation': 'Credit Rating Affirmation',
      'Credit Rating Confirmation': 'Credit Rating Confirmation',
      'Credit Rating Corrected': 'Credit Rating Corrected',
      'Credit Rating Downgrade': 'Credit Rating Downgrade',
      'Credit Rating No-rating': 'Credit Rating No-rating',
      'Credit Rating Matured': 'Credit Rating Matured',
      'Credit Rating Paid-in-full': 'Credit Rating Paid-in-full',
      'Credit Rating Reinstated': 'Credit Rating Reinstated',
      'Credit Rating Set': 'Credit Rating Set',
      'Credit Rating Unchanged': 'Credit Rating Unchanged',
      'Credit Rating Upgrade': 'Credit Rating Upgrade',
      'Credit Rating Withdrawn': 'Credit Rating Withdrawn',
      Fundraising: 'Fundraising',
      Capex: 'Capex',
      'Share Buyback': 'Share Buyback',
      'Capital Increase': 'Capital Increase',
      'Equity Shelf Registration': 'Equity Shelf Registration',
      'Going Private': 'Going Private',
      Investment: 'Investment',
      IPO: 'IPO',
      'IPO Issuance': 'IPO Issuance',
      'IPO Price': 'IPO Price',
      'IPO Lock-up': 'IPO Lock-up',
      'IPO Regulatory Approval': 'IPO Regulatory Approval',
      'IPO Regulatory Scrutiny': 'IPO Regulatory Scrutiny',
      'IPO Rumor': 'IPO Rumor',
      'Name Change': 'Name Change',
      Ownership: 'Ownership',
      'Ownership Decrease Held': 'Ownership Decrease Held',
      'Ownership Increase Held': 'Ownership Increase Held',
      'Ponzi Scheme': 'Ponzi Scheme',
      'Private Placement': 'Private Placement',
      'Public Offering': 'Public Offering',
      'Restructuring Approval': 'Restructuring Approval',
      'Reorganization Complete': 'Reorganization Complete',
      'Reorganization Considered': 'Reorganization Considered',
      'Reorganization Costs': 'Reorganization Costs',
      'Reorganization Delayed': 'Reorganization Delayed',
      'Reorganization Denied': 'Reorganization Denied',
      'Reorganization Failed': 'Reorganization Failed',
      'Restructuring Rejection': 'Restructuring Rejection',
      'Reorganization Savings': 'Reorganization Savings',
      'Reverse Stock Splits': 'Reverse Stock Splits',
      'Rights Issue': 'Rights Issue',
      Savings: 'Savings',
      'Shareholder Rights Plan': 'Shareholder Rights Plan',
      'Spin-off': 'Spin-off',
      'Stock Splits': 'Stock Splits',
      'Trading Delisting': 'Trading Delisting',
      'Trading Halt': 'Trading Halt',
      'Trading Listing': 'Trading Listing',
      'Trading Resumed': 'Trading Resumed',
      Antitrust: 'Antitrust',
      Lawsuit: 'Lawsuit',
      Blackmail: 'Blackmail',
      'Copyright Infringement': 'Copyright Infringement',
      'Patent Infringement': 'Patent Infringement',
      Corruption: 'Corruption',
      Defamation: 'Defamation',
      Discrimination: 'Discrimination',
      Embezzlement: 'Embezzlement',
      Fraud: 'Fraud',
      Sanctions: 'Sanctions',
      'Tax-evasion': 'Tax-evasion',
      'IT Hack': 'IT Hack',
      'Industrial Spying': 'Industrial Spying',
      Explosion: 'Explosion',
      Hijacking: 'Hijacking',
      Award: 'Award',
      'Business Combination': 'Business Combination',
      'Business Contract': 'Business Contract',
      'Government Contract': 'Government Contract',
      'Market Entry': 'Market Entry',
      'Market Exit': 'Market Exit',
      'Market Share': 'Market Share',
      'Product Catastrophe': 'Product Catastrophe',
      'Product Release': 'Product Release',
      'Product Delayed': 'Product Delayed',
      'Product Development': 'Product Development',
      'Product Discontinued': 'Product Discontinued',
      'Product Enhancement': 'Product Enhancement',
      'Product Fault': 'Product Fault',
      'Product Outage': 'Product Outage',
      'Product Pricing': 'Product Pricing',
      'Product Recall': 'Product Recall',
      'Product Review': 'Product Review',
      'Product Side-effects': 'Product Side-effects',
      'Project Abandoned': 'Project Abandoned',
      'Regulatory Product Application': 'Regulatory Product Application',
      'Regulatory Product Approval': 'Regulatory Product Approval',
      'Regulatory Product Approval Denied': 'Regulatory Product Approval Denied',
      'Regulatory Product Warning': 'Regulatory Product Warning',
      'Regulatory Product Review': 'Regulatory Product Review',
      Hirings: 'Hirings',
      Layoffs: 'Layoffs',
      'Workers Strike': 'Workers Strike',
      'Union Pact': 'Union Pact',
      'Shelf Registration': 'Shelf Registration',
      'COVID-19': 'COVID-19',
      MERS: 'MERS',
      SARS: 'SARS',
      Ebola: 'Ebola',
      'Avian Influenza': 'Avian Influenza',
      Plague: 'Plague',
      'African Swine Fever': 'African Swine Fever',
      'Insider Trading': 'Insider Trading',
      'Stock Manipulation': 'Stock Manipulation',
      'Real Estate Bubble': 'Real Estate Bubble',
      'Real Estate Prices': 'Real Estate Prices',
      'Rent Stabilization': 'Rent Stabilization',
      Terrorism: 'Terrorism',
      'War Declared': 'War Declared',
      'War Threat': 'War Threat',
      NFT: 'NFT',
      Blockchain: 'Blockchain',
      'Oil Embargo': 'Oil Embargo',
      'Gas Embargo': 'Gas Embargo',
      'Oil Shortage': 'Oil Shortage',
      'Gas Shortage': 'Gas Shortage',
      'Coal Embargo': 'Coal Embargo',
      'Nuclear Fuel Embargo': 'Nuclear Fuel Embargo',
      'Coal Shortage': 'Coal Shortage',
      'Nuclear Fuel Shortage': 'Nuclear Fuel Shortage',
      'Air Pollution': 'Air Pollution',
      'CO2 Emission': 'CO2 Emission',
      Deforestation: 'Deforestation',
      'Environmental Damage': 'Environmental Damage',
      Waste: 'Waste',
      'Waste Consumption': 'Waste Consumption',
      'Water Pollution': 'Water Pollution',
      'Ozone Depletion': 'Ozone Depletion',
      'Habitat Degradation': 'Habitat Degradation',
      'Human Rights': 'Human Rights',
      'Work Conditions': 'Work Conditions',
      'Health Issues': 'Health Issues',
      Harassment: 'Harassment',
      Diversity: 'Diversity',
      'Child Labor': 'Child Labor',
      Eviction: 'Eviction',
      'Forced Labor': 'Forced Labor',
      'Noise Pollution': 'Noise Pollution',
      'Human Trafficking': 'Human Trafficking',
      'Salary Conditions': 'Salary Conditions',
      'Data Privacy': 'Data Privacy',
      'Green New Deal': 'Green New Deal',
      'Sustainable Finance Initiative': 'Sustainable Finance Initiative',
      'EU Taxonomy': ' EU Taxonomy',
      'EU Circular Economy Package': ' EU Circular Economy Package',
      'Bio Diversity': ' Bio Diversity',
      'Carbon Disclosure Project': ' Carbon Disclosure Project',
      'Climate Change': ' Climate Change',
      'Credit Scoring': ' Credit Scoring',
      'Demographic Change': ' Demographic Change',
      'Design-for-Environment': ' Design-for-Environment',
      'Double Materiality': ' Double Materiality',
      'Eco-management Audit Scheme': ' Eco-management Audit Scheme',
      'Energy Performance': ' Energy Performance',
      'Equal Opportunity': ' Equal Opportunity',
      'European Federation of Financial Analysts': ' European Federation of Financial Analysts',
      'European Financial Reporting Advisory Group': ' European Financial Reporting Advisory Group',
      'Food security': ' Food security',
      'German sustainablity codex': ' German sustainablity codex',
      'Global Reporting Initiative': ' Global Reporting Initiative',
      'International Labour Organisation': ' International Labour Organisation',
      'Land Consumption': ' Land Consumption',
      'Green Lobbying': ' Green Lobbying',
      'Political Sponsorship': ' Political Sponsorship',
      'Prevention of Corruption': ' Prevention of Corruption',
      'Product Environmental Footprint': ' Product Environmental Footprint',
      'Prohibition of Discrimination': ' Prohibition of Discrimination',
      'SA8000-Certificate for Social Responsiblity': ' SA8000-Certificate for Social Responsiblity',
      'Social Standards': ' Social Standards',
      'Sustainability Accounting Standards Board': ' Sustainability Accounting Standards Board',
      'Sustainable Development Goals': ' Sustainable Development Goals',
      Insolvency: ' Insolvency',
      'Liquidity Risk': ' Liquidity Risk',
      'Account Termination': ' Account Termination',
      'Cash Withdrawal': ' Cash Withdrawal',
      'Interest Rates': ' Interest Rates',
      'Artificial Intelligence': ' Artificial Intelligence',
      'Large Language Model': ' Large Language Model',
      'Remote Work': ' Remote Work',
      Shitstorm: ' Shitstorm',
      'Machine Learning': ' Machine Learning',
      'Deep Learning': ' Deep Learning',
      'Artificial Superintelligence': ' Artificial Superintelligence',
      'Artificial General Intelligence': ' Artificial General Intelligence',
      'Embedded Finance': ' Embedded Finance',
      'Banking-as-a-Service': ' Banking-as-a-Service',
      Inflation: ' Inflation',
      'European elections': ' European elections',
      'US presidential elections': ' US presidential elections',
      'Republican Party': ' Republican Party',
      'Democratic Party': ' Democratic Party',
      'Trump-linked stock': ' Trump-linked stock',
      'Secured Debt': ' Secured Debt',
      'Unsecured Debt': ' Unsecured Debt',
      'Revolving Debt': ' Revolving Debt',
      'Installment Debt': ' Installment Debt',
      Mortgages: 'Mortgages',
      'Russia-Ukraine War': 'Russia-Ukraine War',
      'Energy Prices': 'Energy Prices',
      'Sustainability Issues': 'Sustainability Issues',
      Metaverse: 'Metaverse',
      'Virtual Reality': 'Virtual Reality',
      'US-China Strategic Competition': 'US-China Strategic Competition',
      'EU-China Strategic Competition': 'EU-China Strategic Competition',
      'EU-US Strategic Competition': 'EU-US Strategic Competition',
      'Donald Trump': 'Donald Trump',
      'Joe Biden': 'Joe Biden',
      others: 'others'
    }
  },

  ExecutiveSummary: {
    title: 'Executive Summary',
    note: 'This executive summary was generated by Stockpulse\' AI. The summary is based on the last few news items related to the search term. The input news can be in different languages and are integrated into the summary in the output language. The executive summary is trained to recognize the main topics in the input messages and to summarize them in a few sentences.',
    sources: {
      generatedBy: 'This executive summary was generated by the Stockpulse AI.',
      label: 'Sources'
    },
    notices: {
      notEnoughTopRatedSources: 'Not enough top rated sources are available. This might affect the quality of the executive summary'
    },
    empty: 'Not enough top rated sources are available.'
  },

  TitleComponent: {
    empty: {
      associated: 'We could not detect any related financial instrument for the given search term.',
      related: 'No related title found.'
    },
    note: 'This box shows related financial instruments of main detected asset.',
    detectedAsset: {
      note: 'This displays the (stock) prices of the selected entity.'
    }
  },

  Assets: {
    title: {
      top: 'Top Asset',
      related: 'Related'
    }
  },

  ContactSalesDialog: {
    infoText: 'Stockpulse provides data and AI analyzes for more than 60k stocks, 20k cryptocurrencies, indices, commodities, financially relevant topics and people - with a unique history for sentiment analysis going back to 2011. We would be happy to send you an individual offer for access to our databases and AI tools.',
    infoTextShort: 'Stockpulse provides AI analyzes for financially relevant topics and people - with a unique history for sentiment analysis going back to 2011. We would be happy to send you an individual offer for access to our AI tools.'
  },
  LoginPage: {
    alreadyLoggedIn: 'User {user} is already logged in',
    navigateToHome: 'go to index'
  },
  LoginComponent: {
    login: {
      label: 'Login',
      email: {
        label: 'Email'
      },
      password: {
        label: 'Password'
      },
      rememberMe: {
        label: 'Remember me'
      },
      forgotPassword: {
        label: 'Forgot Password?'
      }
    },
    reset: {
      label: 'Reset password',
      email: {
        label: 'Email',
        hint: 'Enter your email address and we\'ll send you a link to change your password.'
      },
      sendLinkToResetPassword: 'Continue',
      cancel: 'Cancel',
      success: {
        label: 'Success',
        message: 'Follow the instructions in your email to reset your password.',
        close: 'ok'
      }
    },
    setPassword: {
      label: 'Set your new password',
      newPassword: {
        label: 'New password'
      },
      newPasswordConfirm: {
        label: 'Confirm new password'
      },
      save: {
        label: 'Save'
      },
      success: {
        label: 'Success',
        message: 'You can now login using your new password',
        close: 'ok'
      }
    }

  },
  AuthenticationService: {
    message: {
      login:
        {
          success: 'Login successful',
          failure: 'Login failed',
          invalidCredentials: 'You have entered an invalid username or password',
          usernameRequired: 'Email required',
          passwordRequired: 'Password required'
        },
      reset: {
        invalidEmail: 'Please provide a valid email address.',
        failure: 'Password reset failed. Please try again or contact support.',
        message: 'The request new password email was sent and should arrive shortly. Please check your inbox and click on the link provided to initiate password reset.'
      },
      setPassword: {
        invalidToken: 'No password reset token provided.',
        invalidPassword: 'Password required.',
        invalidPasswordConfirm: 'Password confirmation required',
        passwordMismatch: 'Passwords do not match.',
        failure: 'Failed to update your password. Please try again by manually copying the link from the reset email to your browser address bar or contact support.',
        message: 'Follow the instructions in your email to reset your password.',
        passwordFormat: 'You have to provide a password with at least 8 characters. In addition, we recommend usage of at least one special character and a number.'
      }
    }
  },
  WebSocketComponent: {
    message: {
      connectionLost: 'Connection lost, reconnecting...'
    }
  },
  Notifications: {
    newMessagesInSources: 'New Messages on {source}',
    newMessage: 'New Message by {name} on {source}'
  }
}
